var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToDoListApp9421(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:#282828;}\r\n\t.st5{fill:#F44545;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#12DD78;}\r\n\t.st8{fill:#E2E2E2;}\r\n\t.st9{fill:#06BA5B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -118.9752,
    y1: -183.5313,
    x2: -24.4713,
    y2: -183.5313,
    gradientTransform: "matrix(-0.6844 0.7291 -0.7291 -0.6844 -127.7251 -16.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.34,92.14c-18.73-18.1-19.66-48.41-2.08-67.7C38.84,5.16,68.28,4.2,87.01,22.3 c18.73,18.1,19.66,48.41,2.08,67.7C71.51,109.28,42.07,110.24,23.34,92.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.336,
    y1: -513.6169,
    x2: -4.5095,
    y2: -513.6169,
    gradientTransform: "matrix(-0.5939 -0.8045 0.8045 -0.5939 445.0571 -281.4822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.06,26.8c20.67-15.71,49.79-11.19,65.05,10.09c15.25,21.28,10.87,51.27-9.8,66.97 c-20.67,15.71-49.79,11.19-65.05-10.09C10.01,72.49,14.4,42.5,35.06,26.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.4357,
    y1: -373.2026,
    x2: -347.4045,
    y2: -373.2026,
    gradientTransform: "matrix(0.9999 0.0124 -0.0124 0.9999 453.6766 434.5686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.93,57.11c-0.32,26.45-21.4,47.62-47.09,47.3c-25.68-0.33-46.25-22.04-45.93-48.48 C18.23,29.48,39.31,8.3,65,8.63C90.69,8.96,111.25,30.66,110.93,57.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -368.8233,
    y1: -518.951,
    x2: -274.6504,
    y2: -518.951,
    gradientTransform: "matrix(0.7673 -0.6413 0.6413 0.7673 632.8808 254.6613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.9,32.09c16.47,20.3,13.85,50.5-5.86,67.46c-19.71,16.96-49.05,14.26-65.52-6.03 C1.04,73.22,3.67,43.01,23.38,26.05C43.09,9.09,72.43,11.79,88.9,32.09z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.66
    },
    width: 242,
    height: 426,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPYAAAGtCAYAAAAlLIlIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEbxJREFUeNrs3Y1u27i2gFFKUdq5 977/q55pk9i6Z4AYw7LcJCXLjpOuBRhx06SNA3/e1I/tlAAAAIAjTG4HdK2CEC7CF8yOn0nkfIaY V2HHP8t0xc/sAYBbTt/1is99+bCnjX8uPzcJmw+cxGvne9ePCnx6gKCngbAnYfPgYa8bP/elwu4F Wn5uGvxaS3Q+YsldBrsGf3/3wJcPiLoXa3l9aoQ+DcYqZvZG3prAaxB17Xr5b063DHy5Y9BpINLR S2uijwQtdNbBz/diXoOYo7+/S+DLBwQdTeY5uF77c2pcFza3Dru8nDd+Pgp8vUV8957SZbRzcb32 sRV5axte1OwJu7YNHcV7Lq7XPq6dSX/Y9vdyw6h7S+0y6LnxuTkIf0r9nWywN/gyvHMQdu8yVUJv Teyrp/dyh6hrS+7o8lR8LK/XpntrSS5ujgg7ijm/fso+norP5YGfi3/7HPz/V8W93CHqqRF1HnJ5 mSt/rk1vk5tbLM2jbepyGpdB1y7l103ZA0OqbHtfHfdy56jLSfz0/jOU15fK39Wm+DQYN2wNvDet o5jfgo9zFvWpmN7nxs+xK+7lDlFHE3rJLvmfn4O/K6f4lu1tO88Y3YHW2/sdRZ2H/Pr+8e39vnq5 nt9XT8V98bxhB9/Nw66d/VWL+qkypfOIn4vrtcCXyjJ92rAkFzbXhH0Own6rXF6Ly+U++1bcR0/F /x3FvXlqH7kUb0X9VESdx/ut+Fi7LMGy/Kn4/5KwuUPYp0rYr9mkfnm//vJ+H30N9g3VnIOl+Ka4 lytj3hL1UkznS8zRJY99acTt0BdHR17G3ZvW5YR+fo+6d39Njbinj5zY0VJ8bkzpMuDv2SX/XB53 /v3RL2pkYguc3tSuTezLHuxTI+yXYlL/7Nxfezvu5sb0vlnY08B29eVSTunvRdB/FXGXkX8rlu6t sB3P5trAe0vxchn+WoR9uTwH+4amwZ/hXPnauy3Fe8eql2IJ/r0I+q8s7PJ6GXb5i+od0x6NWvR/ 9jZ1azneWornO8suk/pnY1q3wo4OrdWeIDI0tZedQUefb0WdL7P/Cfd/go9/BVN72Rm2eNmzHB/Z eZbvLHt5v5/+DKb1tDHqtbK9PTy1r1mK945X96LOL/9bxF0uyZ8HtrH3TGsYmdh53L2l+LfKfbW2 w2wdvEyVKd2d2suOoHuT+imY1uXy+xL05ZJP7lrY0cSeKr84cXNU2Cn9el74qbPzrHb0ZiqW1b1j 5OUTTqatU3vvUrx3eKs1rf8qJnV+Kaf2t0rY0Zlns6C5wY60KL7yTLPnxv00dXbI9cJet07tZWPQ rdBrx66fi4n9vTKt/y+b2OV2dnnIa+TMM2FzVNRpYDv7EnYt6LkIsLWsLy+X7z8H9++bLcVb29dl 1LWwa9vZZdj5SSrRHkYnpnDL5XgaCLv27MR827h12Czfu76kX58Rdn6/n2+e2ssVQdeW5dFZZmXU Udx52CPLcGFzq6h7U/sSYHRYK3WmdHkaan55Cqb20I6zvdvY0U6zaDv7WzC1o7jzHWfldkvrEJeY uceSPD8LLV82R8eqa1G/pvppqLW4y+E19AKIRxzumjs7z8pt7NrJKOWfv6f6qaStqJ2IwhFTuvb3 tbjnLL7a6aK1Cf8WRJ1fLu28Fff3c9pw6GvZGXNrGf6Ufj+NtLatXZ5Omp8jHh27js4NHw1X3OwJ u/x4LgKfO9vUtajz88q/pd+f5lm7v0fb2odO7NSZ2nng39Lvz+aqxVxG/bxxh5lwufVyPKX23uoU RF2ezPI9/X5CS+uQ7jlocPfOs96LKYyceRY9RfN78XfPleX3ktovqhAFLXKuneC1eMqTRmpR59vh b8H9v/eaA3NleT8Fy/HDd561pnXtDLTnxg0rn8HVOhlF1NxTbbv2nH7d+50qS/DnLOzn1H5iU23v emuVmm4d9siLK9Rez6w1nWsvQzxdsW0NWzczy2DLz8+VSf6URX05Jh1N5uglwFrPgyjbC5+nveyM eOTVSFuBj7wa6VOK3wGkFbTQueWSvLZpmu/YenoPu7dyHYl65JmLN5nYvWV5L/JoOjsJhUea3Gsj 8Dn9foZYtHLtDbqR19BvbSL8spy45kaP7ER7SvFrg49sT7T2gIuae0XeGiajDSyNVWq006y1Sg4H 23zFDdzyjh+1G9p7zy6HtXj07e9pRwdPA9O59043XfNBNzR6P6154yXaSQCPFnfrHWV7bzDZem+6 kRcPma4Ne/Rsrmh7ewpu7DSw7J46KwV4tNCnyrCbgtXoyPVpb+DzlTeo9Wql0RvXz2lsW9rE5rNM 7dFnP84DgW89ClQdwtfuPOsFPXrpPWjAZ4g9evvoeXDgjewwvss29siy5JrQvdooX2lp3ov7sKNB 8w1vWG9ZIlS+QsBpYBDtXb3u7mQ+8EZOnT+Pfu/oLxE+Q/TTFdvou8074t0S8JTG33bHKaJ89m3r 0eV5GlhiX7WqvfVSfOujmYj5KkvzaeB+v+UU6dZRqEPDnnZ8rW1r/uRp3ov7sEE3P/AvBEz/TxD2 JG7YtR19t73iI0uGzSeuA8c44kkgwoX+dD3q8596Gxv+xAeEkR1ok7Dh64X/sBPb0h0efBsbeMDh Jmz4gnELGyzFAWEDwgaEDQgbhA0IGxA2IGxA2CBsvwIQNiBsQNiAsAFhg7ABYQPCBoQNCBuEDQgb EDYgbEDYgLBB2ICwAWEDwgaEDcIGhA0IGxA2IGxA2CBsQNiAsAFhA8IGYQPCBoQNCBsQNiBsEDYg bEDYgLABYYOwAWEDwgaEDQgbEDYIGxA2IGxA2ICwQdiAsAFhA8IGhA0IG4QNCBsQNiBsQNggbEDY gLABYQPCBoQNwgaEDQgbEDYgbBA2IGxA2ICwAWEDwgZhA8IGhA0IGxA2CBsQNiBsQNiAsAFhg7AB YQPCBoQNCBuEDQgbEDYgbEDYgLBB2ICwAWEDwgaEDcIGhA0IGxA2IGxA2CBsQNiAsAFhA8IGYQPC BoQNCBsQNiBsEDYgbEDYgLABYYOwAWEDwgaEDQgbEDYIGxA2IGxA2ICwQdiAsAFhA8IGhA0IG4QN CBsQNiBsQNggbEDYgLABYQPCBoQNwgaEDQgbEDYgbBA2IGxA2ICwAWEDwgZhA8IGhA0IGxA2CBsQ NiBsQNiAsAFhg7ABYQPCBoQNCBuEDQgbEDYgbEDYgLBB2ICwAWEDwgaEDcIGhA0IGxA2IGxA2CBs QNiAsAFhA8IGYQPCBoQNCBsQNiBsEDYgbEDYgLABYYOwAWEDwgaEDQgbEDYIGxA2IGxA2ICwQdiA sAFhA8IGhA0IG4QNCBsQNiBsQNggbEDYgLABYQPCBoQNwgaEDQgbEDYgbBA2IGxA2ICwAWGDsP0K QNiAsAFhA8IGhA3CBoQNCBsQNiBsEDYgbEDYgLABYQPCBmEDwgaEDQgbEDYIGxA2IGxA2ICwAWGD sAFhA8IGhA0IG4QNCBu40vp+ETYgbBD2ByxDgG29rFuW8CY2PMZAK8O9agDOV/6Qmx5FQMD3WcGa 2PD4m6LrI4V9zTS3CuBP234+dIrPH3AjgBubPyhUkfMnTONy5blWVqRrY5W6fkTYW6JdBc0ftpyO Ni3XzveujY/r6KbufPANHL2Rhz9CwQPE3bsfj07su25jrxsfNWrH5aJHqLXzyxA8jx5zGrz/rgNN Xb3pequleHTpTezRaQ+PvF3dWzqPNNIbmHcLuzd1R6a+cPlq07wV8Tm43or+rhN73fio1Puh7Wzj s07rkZDPQdTnIPDNq9n5oBuRGjfk3LneW7KLnUedyGtnuziKOm/gPNDD4RN7zw6C6BHp3Hik2rOt AY++7D4HA+0UhL0l8mYX156gUgt6bTwiXW7UKbjRluh8tmndW4pH9/tT0EIU9ybzzphHlhxr5Qad gshPwaRPA5HDRy7BW1P6VLl+Ci5bJvfhYY8+OkU35tyJ/NwIvLX0gXvsGIsmdmvz85/79VvWwFvx 51bgvU3UcMAtGx+ppoHAayGXN+itcgPzr52zf2t6/zhnP0P585Q3bnJf5KDt5t7Ejraha5e34L5/ qrTQCry7al2uePRaO9vTIzfuVHx8Kv6N6f0yB/G2HnDgFpHXluGtpXZ+f3+t/Pk1mOBbtrPXa8Ne i4haOwlOwY3Ib8xr5dHr7T3kOQs7j7n2uehGm9xcO6VTMCXPjc3PWsivwaXWwege8nTNxF6DQHrb 1r0b9PLfy7fsz8v7xH7KluNTJdS5+LlWAfOBS/D8Uq5E8/v6Syfutysm9qFL8ZQ9ckXL8LfgBtZu 5CXq2qRes79bs6/pxS16bhX12tiP9Jrdx18al1rcb4M70g4Lu7bDKtppdqpM6/JG/fzv5Tmb1HMQ 9vr+NWXc5bJ8Cpbgtre5JvJ1YIX61on6Z/Yxv5SBj0QdDdib7jzrbVuXUT8XS/Cn9OshuDLqtbL9 PTWibjHJRTvydeU2dW2Q5ff1MuIfRcw/gqijHWm79owvV/xyorjfgiV4HnMt6jn9fviq9u/PQdxp Z+AwOqlHVqcvWcB51H9XIs8n92uwFN91gsqW49itHWi1iX3ZIfaShZzH/dTYrq79u7UHgV7cAmfP FI/OMIsO55Yr0h/Z5e8s6r8rwZdTu3WyytAyfM/EXoOop0bcL+//T34po56DbffLv/f8/rH8nmhJ Lm6OCrt15Kc3rS9R/6cR90tlYr+lO56g0jqGnUc4p39PNsmndhl0Oamjf+9yQ5fK1C4nd7Is50Y7 y1r7ksr9R3nY/6nEXYb92liK7zrktRzwS4im9iXul07QtQeK/JfW2iaPpvYkaHber9fOErw8/7uc 1vk29d+NuMs94yNRH3qCyjVT+xJeFHVtm7p8JPz2flmKbfPLvzulfXvJRW/J3RtY5bQ+pfgErJGw /y62uV+CiX31UzeXA35BtaldW5JH8UXL73++53v2S3suluPzxh1pQmZL0CnFL5DQOk+jto1dizp/ ENiyR/zwE1RGpvblRueBjQS9VvYwXn5Z3ytL8SVYjpfb2pNJzeDkXjvb17Vp3ZrYP4qdZa2o8z3i h7zQwnLgI905C+fU2O5tPSCcKlH/LJbiS7C0b03skZgF/2ctvVsTOzWW4W+pfbp0GfaPFB/HHj3M dbPj2CNTOxVL8lMj6hRM69ryptx5tjQmdv4kEXGzJezoTLPoENcp/frsrNrpoz9S/eyzkb3hV73e 33LwL26txN0KOprWedT5tH7OluJz+v2wl0Nf7F1xpsa0rj3funXK9Esl4vzjnlNIb364qza180e5 ke8bmda1009rZ6yNHPaqBS1wQbd2ntW2r2tnnJXL8T3P6Dos6KMmdh74Wtne3hr2WyXsJf2+R/yp s/PMWWjsXW1GEzt6IZHX1H/dgZfK1428asrWzYpDl+LT4PReB8N+zsJeUnw66si07m1fi9w2d+u+ 2Qs7eumjPN6X4GsO3Vl2j4mdO28Ie8lu+HMQ85Yzz4TNEWFHLyncepHC11R/4cLoBTx7r6v/IUvx 3i/u3FiKn9O/L4V0ueFL+vcc8+j88tGwk7DZEHZratfOPitPL619jF5qePQ1zT5sYkc70sq4Rx4J n9K/Z6uVJ6LUlt9bzxUXMr2daL031TsHO9OiZXr0+vrrraK+xR299oqi+fV8J1d+eapcjz5OnR1m pjVHTuyU+m+od+p8rL0pxnqrqG91565FVQtvboQ+B/FPg1N6Mq25YnL3Ti9tvcle633roimdjoz6 lnf2VtzRBI9inxofR04hnT7g9vN5pnUr7t42d/Te1qNvF91766CHC3vr9K49YWQe/Lqtz+YSM6NL 8tRYlvfe/3o05tE3tn+osFtx16b46KGr6HNpx04zoZvYo2/8uG68pMHpvN4yuo8OPKWxY9F7lt7C Zt34dyPTe+1sl6d7B/2Rd+ppx7Z4Gvi453aJWthbIt/ycR34/vSVwh4NvBfxEWHD3undC7b1dekr hz26PTxtvG4yc/Q0Xzde7/3dHxF272cZ+bywuVfYI1P9w4L+DHf4I2MVNkdsf/e+dv0s8Xy22OER HwyE4vYgXAAAAADgZv5fgAEAuRfNhfsUbOsAAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 32.8973 9.1773)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.51,103.5H40.92c-3.1,0-5.61-2.51-5.61-5.61V17.27c0-3.1,2.51-5.61,5.61-5.61h36.59 c3.1,0,5.61,2.51,5.61,5.61v80.62C83.12,100.98,80.61,103.5,77.51,103.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 59.22,
    cy: 12.49,
    r: 0.41
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.92,101.83c-2.18,0-3.95-1.77-3.95-3.95V17.27c0-2.18,1.77-3.95,3.95-3.95h36.59 c2.18,0,3.95,1.77,3.95,3.95v80.62c0,2.18-1.77,3.95-3.95,3.95H40.92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.15,48.73H41.29c-0.44,0-0.79-0.35-0.79-0.79v-12.5c0-0.44,0.35-0.79,0.79-0.79h35.86 c0.44,0,0.79,0.35,0.79,0.79v12.5C77.94,48.38,77.58,48.73,77.15,48.73z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.41,62.28c-0.24,0-0.43-0.19-0.43-0.43v-8.54c0-0.24,0.19-0.43,0.43-0.43h8.54 c0.24,0,0.43,0.19,0.43,0.43v8.54c0,0.24-0.19,0.43-0.43,0.43H43.41z M44.08,53.74c-0.13,0-0.24,0.11-0.24,0.24v7.21 c0,0.13,0.11,0.24,0.24,0.24h7.21c0.13,0,0.24-0.11,0.24-0.24v-7.21c0-0.13-0.11-0.24-0.24-0.24H44.08z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.41,78.17c-0.24,0-0.43-0.19-0.43-0.43v-8.54c0-0.24,0.19-0.43,0.43-0.43h8.54 c0.24,0,0.43,0.19,0.43,0.43v8.54c0,0.24-0.19,0.43-0.43,0.43H43.41z M44.08,69.62c-0.13,0-0.24,0.11-0.24,0.24v7.21 c0,0.13,0.11,0.24,0.24,0.24h7.21c0.13,0,0.24-0.11,0.24-0.24v-7.21c0-0.13-0.11-0.24-0.24-0.24H44.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,69.76c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h12.2c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,78.17c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,75.36c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,72.56c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.41,94.05c-0.24,0-0.43-0.19-0.43-0.43v-8.54c0-0.24,0.19-0.43,0.43-0.43h8.54 c0.24,0,0.43,0.19,0.43,0.43v8.54c0,0.24-0.19,0.43-0.43,0.43H43.41z M44.08,85.51c-0.13,0-0.24,0.11-0.24,0.24v7.21 c0,0.13,0.11,0.24,0.24,0.24h7.21c0.13,0,0.24-0.11,0.24-0.24v-7.21c0-0.13-0.11-0.24-0.24-0.24H44.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,85.65c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,94.05c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,91.25c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,88.45c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.41,30.5c-0.24,0-0.43-0.19-0.43-0.43v-8.54c0-0.24,0.19-0.43,0.43-0.43h8.54 c0.24,0,0.43,0.19,0.43,0.43v8.54c0,0.24-0.19,0.43-0.43,0.43H43.41z M44.08,21.96c-0.13,0-0.24,0.11-0.24,0.24v7.21 c0,0.13,0.11,0.24,0.24,0.24h7.21c0.13,0,0.24-0.11,0.24-0.24V22.2c0-0.13-0.11-0.24-0.24-0.24H44.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,22.1c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,30.5c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,27.7c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,24.9c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.41,46.39c-0.24,0-0.43-0.19-0.43-0.43v-8.54c0-0.24,0.19-0.43,0.43-0.43h8.54 c0.24,0,0.43,0.19,0.43,0.43v8.54c0,0.24-0.19,0.43-0.43,0.43H43.41z M44.08,37.85c-0.13,0-0.24,0.11-0.24,0.24v7.21 c0,0.13,0.11,0.24,0.24,0.24h7.21c0.13,0,0.24-0.11,0.24-0.24v-7.21c0-0.13-0.11-0.24-0.24-0.24H44.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.18,37.98c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h12.2c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.18,46.39c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.18,43.59c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 s-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.18,40.79c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,53.87c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.36c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,62.28c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h16.43c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,59.48c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h12.2c0.27,0,0.5,0.22,0.5,0.5 s-0.22,0.5-0.5,0.5H57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.18,56.67c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5H71.5c0.27,0,0.5,0.22,0.5,0.5 c0,0.27-0.22,0.5-0.5,0.5H57.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.56,40.51l-0.61-0.61c-0.04-0.04-0.09-0.04-0.13,0l-2.4,2.4c-0.04,0.04-0.09,0.04-0.13,0l-1.44-1.44 c-0.04-0.04-0.09-0.04-0.13,0l-0.61,0.61c-0.04,0.04-0.04,0.09,0,0.13l2.19,2.18c0.04,0.04,0.09,0.04,0.13,0l3.15-3.14 C50.6,40.6,50.6,40.55,50.56,40.51z"
  })))))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8_copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13_copy"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -246.3653 145.0996)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      display: "inline",
      fill: "#939598",
      fontFamily: "'Mont-Regular'",
      fontSize: "8.9637px"
    }
  }, "A simple shopping cart like in Amazon"), /*#__PURE__*/React.createElement("tspan", {
    x: 171.71,
    y: 0,
    style: {
      display: "inline",
      fill: "#2B29A1",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "79.7258px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoListApp9421);
export default __webpack_public_path__ + "static/media/to-do-list-app-9421.d1ed7c99d9c15679577d25cebc05b3ef.svg";
export { ForwardRef as ReactComponent };